<template lang="pug">
.pt-4.pb-16
  template(v-for="table in reorganizedTables")
    .headline.py-2.pl-3(v-if="table.title", v-text="table.title")
    v-select(
      v-else-if="table.filterable",
      style="width: max-content",
      solo,
      flat,
      hide-details,
      :items="table.filter.items",
      :value="table.filter.value",
      @input="table.filter.onUpdate"
    )
      template(v-slot:selection="{ item }")
        .headline(v-text="item.text")

    v-data-table.elevation-1.mb-8(
      :headers="headers",
      :items-per-page="5",
      :items="table.items",
      item-key="ID",
      multi-sort,
      :sort-by="table.sortBy.value",
      @update:sort-by="table.sortBy.onUpdate"
    )
      template(v-slot:item.company_name="{ item }")
        span(v-text="companyName(item)")
      template(v-slot:item.review_start="{ value }")
        span(v-text="fDate(value)")
      template(v-slot:item.review_deadline="{ value }")
        span(v-text="fHours(value)")
      template(v-slot:item.status="{ value }")
        span(v-text="statusLabel(value)")
      template(v-slot:item.payment_status="{ value }")
        span.font-weight-bold.text-uppercase.text-no-wrap(
          :style="{ color: value ? '#50bdc1' : '#b71c1c' }",
          v-text="value ? 'paid' : 'not paid'"
        )
      template(v-slot:item.Actions="{ item }")
        v-btn(color="primary", @click="openCase(item)") open
</template>

<script>
import { mapState } from "vuex";
import { format, formatDistance } from "date-fns";
import { filters } from "./filters";
import { statuses } from "@/data/statuses";

export default {
  name: "expert-cases",

  data: () => ({
    headers: [
      { text: "ID", value: "ID" },
      { text: "Category", value: "case_profile_type" },
      { text: "Applicant", value: "company_name" },
      { text: "Submitted", value: "review_start" },
      { text: "Time remaining", value: "review_deadline" },
      { text: "Status", value: "status" },
      { text: "Payment", value: "payment_status" },
      { text: "Actions", value: "Actions", sortable: false },
    ],

    tables: [
      {
        title: "For expert review",
        filter: {
          value: 3,
        },
        sortBy: {
          value: ["ID"],
        },
      },

      {
        filterable: true,
        filter: {
          items: filters,
          value: 1,
        },
        sortBy: {
          value: ["ID"],
        },
      },
    ],
  }),

  computed: {
    ...mapState("expert", {
      companies: ({ companies }) => companies,
      usercases: ({ usercases }) => usercases,
    }),

    reorganizedTables() {
      return this.tables.map((table) => {
        const el = { ...table };
        el.items = this.usercases.filter((item) => {
          const filteredStatuses = filters.find(
            (filter) => filter.value === el.filter.value
          )?.statuses;
          if (!filteredStatuses) return true;
          return filteredStatuses.includes(item.status);
        });
        el.sortBy.onUpdate = (v) => (table.sortBy.value = v);
        if (el.filterable) {
          el.filter.onUpdate = (v) => (table.filter.value = v);
        }
        return el;
      });
    },
  },

  methods: {
    companyName({ company_id }) {
      const company_name =
        this.companies.find(({ CompanyProfile: { ID } }) => ID === company_id)
          ?.CompanyProfile.name ?? "???";
      return company_name;
    },

    fDate(v) {
      return format(new Date(v), "do MMM yyyy");
    },

    fHours(v) {
      return formatDistance(new Date(), new Date(v));
    },

    statusLabel(v) {
      return statuses.find(({ alias }) => alias === v)?.label ?? "???";
    },

    openCase({ status, ID }) {
      if (status == "ready_for_review") {
        this.$store.dispatch("expert/usercase/takeCaseInReview", ID);
      }
      this.$router.push("/expert/cases/" + ID + "/overview");
    },
  },
};
</script>